import React, { useState, useEffect } from 'react';
import VoteBar from './VoteBar';
import './ElectorateList.css';

// Import all state prediction files
import actPredictions from '../data/predictions/predictions2025_act.json';
import nswPredictions from '../data/predictions/predictions2025_nsw.json';
import ntPredictions from '../data/predictions/predictions2025_nt.json';
import qldPredictions from '../data/predictions/predictions2025_qld.json';
import saPredictions from '../data/predictions/predictions2025_sa.json';
import tasPredictions from '../data/predictions/predictions2025_tas.json';
import vicPredictions from '../data/predictions/predictions2025_vic.json';
import waPredictions from '../data/predictions/predictions2025_wa.json';

const ElectorateList = ({ onElectorateSelect, selectedElectorate, searchQuery }) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const [filter, setFilter] = useState('all');
  const [allPredictions, setAllPredictions] = useState([]);

  useEffect(() => {
    // Combine all predictions
    const predictions = [
      ...actPredictions,
      ...nswPredictions,
      ...ntPredictions,
      ...qldPredictions,
      ...saPredictions,
      ...tasPredictions,
      ...vicPredictions,
      ...waPredictions
    ];
    setAllPredictions(predictions);
  }, []);

  // Collapse list when electorate is selected or searched
  useEffect(() => {
    if (selectedElectorate || searchQuery) {
      setIsExpanded(false);
    }
  }, [selectedElectorate, searchQuery]);

  const getPartyColor = (partyCode) => {
    switch (partyCode) {
      case 'LP':
      case 'LNP':
      case 'CLP':
      case 'NP':
        return '#1E3D8F';
      case 'ALP':
        return '#E13940';
      case 'GRN':
        return '#2E8B57';
      case 'IND':
        return '#800080';
      case 'KAP':
        return '#FFD700';
      case 'CA':
        return '#FFA500';
      default:
        return '#6c757d';
    }
  };

  const getWinningParty = (prediction) => {
    if (prediction.prediction['2ppProjected']) {
      return prediction.prediction['2ppProjected'].candidates[0].partyCode;
    }
    return prediction.candidates[0].partyCode;
  };

  const filteredPredictions = allPredictions.filter(prediction => {
    if (filter === 'all') return true;
    return getWinningParty(prediction) === filter;
  });

  const uniqueParties = [...new Set(allPredictions.map(getWinningParty))];

  return (
    <div className="electorate-list-container">
      <div className="list-header">
        <button 
          className="toggle-button"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded ? '▼ Hide Electorates' : '▶ Show Electorates'}
        </button>
        <div className="filter-section">
          <label htmlFor="party-filter" className="filter-label">Projected Winner:</label>
          <select 
            id="party-filter"
            value={filter} 
            onChange={(e) => setFilter(e.target.value)}
            className="party-filter"
          >
            <option value="all">All Parties</option>
            {uniqueParties.map(party => (
              <option key={party} value={party}>{party}</option>
            ))}
          </select>
        </div>
      </div>

      {isExpanded && (
        <div className="electorate-list">
          {filteredPredictions.map(prediction => {
            const tppCandidates = prediction.prediction['2ppProjected']?.candidates || 
              prediction.candidates.slice(0, 2);

            return (
              <div 
                key={prediction.electorateName}
                className={`electorate-item ${selectedElectorate === prediction.electorateName ? 'selected' : ''}`}
                onClick={() => onElectorateSelect(prediction.electorateName)}
              >
                <span className="electorate-name">{prediction.electorateName}</span>
                <div className="electorate-2pp">
                  <VoteBar
                    votes={tppCandidates[0].projectedVotes}
                    otherVotes={tppCandidates[1].projectedVotes}
                    partyCode={tppCandidates[0].partyCode}
                    otherPartyCode={tppCandidates[1].partyCode}
                    showVotes={false}
                    partyColor={getPartyColor(tppCandidates[0].partyCode)}
                    otherPartyColor={getPartyColor(tppCandidates[1].partyCode)}
                  />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ElectorateList; 